export default __webpack_public_path__ + "static/media/ES_Car_Lora_Thumb.3b044dc3.jpg";